<app-uni-page
  [parent]="this"
  *ngIf="isPageReady"
  pageTitle="Administration: GL Submissions"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
>
</app-uni-page>

<ng-template #bodyTemplate>
  <app-ag-grid [gridOptions]="glGridOptions" [rowData]="glSubmissions"></app-ag-grid>
</ng-template>

<ng-template #footerTemplate>
  <div class="right-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
